const PRECISION = 10;

export { PRECISION as P };
//# sourceMappingURL=constants.js.map
